module.exports = __webpack_public_path__ + "static/media/15-2.bd566bc4.mp3";